var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6309 23.3455L21.3732 18.0879C21.1359 17.8506 20.8143 17.7187 20.4768 17.7187H19.6172C21.0727 15.8572 21.9375 13.5158 21.9375 10.9687C21.9375 4.90957 17.0279 0 10.9687 0C4.90957 0 0 4.90957 0 10.9687C0 17.0279 4.90957 21.9375 10.9687 21.9375C13.5158 21.9375 15.8572 21.0727 17.7187 19.6172V20.4768C17.7187 20.8143 17.8506 21.1359 18.0879 21.3732L23.3455 26.6309C23.8412 27.1266 24.6428 27.1266 25.1332 26.6309L26.6256 25.1385C27.1213 24.6428 27.1213 23.8412 26.6309 23.3455ZM10.9687 17.7187C7.24043 17.7187 4.21875 14.7023 4.21875 10.9687C4.21875 7.24043 7.23515 4.21875 10.9687 4.21875C14.6971 4.21875 17.7187 7.23516 17.7187 10.9687C17.7187 14.6971 14.7023 17.7187 10.9687 17.7187Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_68"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b668462e07082cc8612dda51dde1aec5.svg";
export { ForwardRef as ReactComponent };